import { Metric } from '../initiative-client/initiative-client.type';

enum TaskPriority {
  HIGHEST = 'Highest',
  HIGH = 'High',
  MEDIUM = 'Medium',
  LOW = 'Low',
  LOWEST = 'Lowest',
  UNKNOWN = 'Unknown',
}

type Task = {
  id: string;
  title: string;
  eligible_for_updates: boolean;
  name: string;
  description: string;
  points: number;
  raw_type: string | null;
  raw_type_label: string | null;
  type: string;
  current_sprint_id: string;
  current_sprint_name: string;
  epic_key: string;
  current_section_id: string;
  created_date: string;
  due_date: string;
  ready_for_deployment_date: string;
  is_deleted_externally: boolean;
  url: string;
  dependencies: number;
  last_seen_date: string;
  subproject: string;
  project_id: string;
  epic: string;
  assignee_name: string;
};

type MinifiedTask = {
  id: string;
  name: string;
  title: string;
  description: string;
  created_date: string;
  points: number;
  project: string;
  type: string;
  raw_type: string | null;
  raw_type_label: string | null;
  url: string;
  epic: {
    id: string;
    name: string;
    title: string;
    url: string;
  } | null;
  initiatives: {
    id: string;
    name: string;
  }[];
  transitions?: {
    status: string;
    changed_by: string;
    changed_at: string;
  }[];
};

type SimpleEpic = {
  id: string;
  title: string;
  name: string;
  created_date: string;
  due_date: string | null;
  projects: {
    id: string;
    name: string;
  }[];
};

type StrategicEpic = {
  id: string;
  title: string;
  name: string;
  created_date: string;
  due_date: string | null;
  contributing_projects: {
    id: string;
    name: string;
  }[];
  parent_project: {
    id: string;
    name: string;
  } | null;
  percent_progress: number;
  scope_increase_tasks_3m: number;
  scope_increase_points_3m: number;
};

type Epic = {
  id: string;
  title: string;
  name: string;
  description: string | null;
  points: number | null;
  priority: TaskPriority;
  created_date: string;
  due_date: string | null;
  projects: {
    id: string;
    name: string;
  }[];
  url: string;
  subtasks_count: number;
  subtasks_completed_count: number;
};

type ExtendedEpic = Epic & {
  key: string;
  due_date: string | null;
  n_due_date_changes: number;
  subtasks_total_points: number;
  subtasks_completed_points: number;
  activity_start_date: string | null;
  activity_end_date: string | null;
  percent_progress: number;
  percent_elapsed: number;
  total_subtasks_over_time: Metric;
  completed_subtasks_over_time: Metric;
  contributing_teams_over_time: Record<string, Metric>;
  contributing_boards_over_time: Record<string, Metric>;
};

enum TaskStatus {
  Backlog = 'Backlog',
  Blocked = 'Blocked',
  WIP = 'In Progress',
  Review = 'Review',
  Test = 'In QA',
  Deployable = 'QA Passed',
  Done = 'Done',
}

export { TaskStatus };
export type { Epic, ExtendedEpic, MinifiedTask, SimpleEpic, StrategicEpic, Task };
